/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {ExtensionAttributeFormComponent as ɵc} from './extensionattribute-form/extensionattribute-form.component';
export {ExtensionAttributeComponent as ɵb} from './extensionattribute.component';
export {declaration as ɵa} from './extensionattribute.module';
export {ExtensionAttributeRoutes as ɵd} from './extensionattribute.routing';